import { defineStore } from 'pinia'
import { ref, reactive, watch, computed } from 'vue'
import { useContactStore } from '../stores/contacts'
import { useAuthStore } from './auth'
import { useDigitalBankStore } from '@stores/digitalBank.js'
import { log10 } from 'chart.js/helpers'
export const useTagFilterStore = defineStore('tagFilter', () => {
  const contactsStore = useContactStore()
  const digitalStore = useDigitalBankStore()
  const user = useAuthStore()
  const expandNet = ref(user?.progress?.expand_network)
  const isFilters = ref(false)
  const reset = ref(false)
  const digital = ref(false)
  const accessLevel = ref('')
  const expertiseLevel = ref('')
  const languages = ref('')
  const industries = ref('')
  const directions = ref('')
  const competences = ref('')
  const cities = ref('')
  const countries = ref('')
  const selects = ref([])
  const model = ref([])
  const modelLevel = ref([])
  const modelAccess = ref([])
  const languagesArr = ref([])
  const countriesArr = ref([])
  const citiesArr = ref([])

  const filters = reactive({
    tags: [],
    access_level: [],
    expertise_level: [],
    languages: [],
    countries: [],
    cities: []
  })

  const tagText = reactive({
    tags: [],
    access_level: [],
    expertise_level: [],
    languages: [],
    countries: [],
    cities: []
  })

  const handleTags = (tag) => {
    switch (tag.label) {
      case 'tags':
        tagText.tags = tag.options
        break
      case 'access_level':
        tagText.access_level = tag.options
        break
      case 'expertise_level':
        tagText.expertise_level = tag.options
        break
      case 'languages':
        tagText.languages = tag.options
        break
      case 'countries':
        tagText.countries = tag.options
        break
      case 'cities':
        tagText.cities = tag.options
        break
      default:
        break
    }
  }
  const handleApply = () => {
    accessLevel.value = filters.access_level.join(',')
    expertiseLevel.value = filters.expertise_level.join(',')
    languages.value = filters.languages.join(',')
    industries.value = filters.tags
      .filter((tag) => tag.includes('industries'))
      .map((tag) => tag.split('-')[0])
      .join(',')
    directions.value = filters.tags
      .filter((tag) => tag.includes('directions'))
      .map((tag) => tag.split('-')[0])
      .join(',')

    competences.value = filters.tags
      .filter((tag) => tag.includes('competences'))
      .map((tag) => tag.split('-')[0])
      .join(',')

    countries.value = filters.countries.join(',')
    cities.value = filters.cities.join(',')
    if (!digital.value) {
      contactsStore.getContacts({
        take: 24,
        isFork: true,
        accessLevel: accessLevel.value,
        expertiseLevel: expertiseLevel.value,
        languages: languages.value,
        industries: industries.value,
        directions: directions.value,
        competences: competences.value,
        countries: countries.value,
        cities: cities.value,
        expandNet: expandNet.value
      })
    }

    if (digital.value) {
      digitalStore.getContactsBank(
        true,
        true,
        24,
        accessLevel.value,
        expertiseLevel.value,
        languages.value,
        industries.value,
        directions.value,
        competences.value,
        countries.value,
        cities.value
      )
    }
  }

  const handleDelete = (tag) => {
    const key = Object.keys(tagText).find((key) => {
      return tagText[key].some(
        (el) => el.id === tag.id && el.title === tag.title
      )
    })

    const filterKey =
      {
        // access_level: 'text',
        // expertise_level: 'title',
        default: 'id'
      }[key] || 'id'

    if (key === 'tags') {
      filters.tags = filters.tags.filter((el) => el !== tag.idLabel)
      tagText.tags = tagText.tags.filter((el) => el.idLabel !== tag.idLabel)
      model.value = model.value.filter((el) => filters.tags.includes(el))
    } else {
      tagText[key] = tagText[key].filter((el) => el !== tag)
      filters[key] = filters[key].filter((el) => el !== tag[filterKey])
      if (key === 'expertise_level') {
        modelLevel.value = filters['expertise_level']
      }
      if (key === 'access_level') {
        modelAccess.value = filters['access_level']
      }
      if (key === 'languages') {
        languagesArr.value = filters['languages']
      }
      if (key === 'countries') {
        countriesArr.value = filters['countries']
      }
      if (key === 'cities') {
        citiesArr.value = filters['cities']
      }
    }

    handleApply()
  }

  const resetTags = () => {
    tagText.tags = []
    tagText.access_level = []
    tagText.expertise_level = []
    tagText.languages = []
    tagText.countries = []
    tagText.cities = []
    filters.tags = []
    filters.access_level = []
    filters.expertise_level = []
    filters.languages = []
    filters.countries = []
    filters.cities = []
  }
  const resetInsideFilter = async (modelType) => {
    if (modelType === 'tags') {
      tagText.tags = []
      model.value = []
    }
    if (modelType === 'languages') {
      tagText.languages = []
      languagesArr.value = []
    }
    if (modelType === 'countries') {
      tagText.countries = []
      countriesArr.value = []
    }
    handleApply()
  }
  const onClear = async () => {
    resetTags()
    selects.value = []
    model.value = []
    modelLevel.value = []
    modelAccess.value = []
    languagesArr.value = []
    countriesArr.value = []
    citiesArr.value = []
    reset.value = true
    if (digital.value) {
      await digitalStore.getContactsBank({ take: 24, isFork: true })
    } else {
      await contactsStore.getContacts({ take: 24, isFork: true })
    }
    isFilters.value = false
  }
  const containsNonEmptyArray = (obj) => {
    for (const key in obj) {
      if (Array.isArray(obj[key]) && obj[key].length > 0) {
        return true
      }
    }
    return false
  }

  watch(
    tagText,
    (newVal) => {
      isFilters.value = containsNonEmptyArray(newVal)
      // Object.values(tagText).some((el) => el !== null)
    },
    { deep: true }
  )
  return {
    filters,
    tagText,
    handleTags,
    handleDelete,
    handleApply,
    resetTags,
    isFilters,
    onClear,
    digital,
    accessLevel,
    expertiseLevel,
    languages,
    industries,
    directions,
    competences,
    countries,
    cities,
    selects,
    model,
    modelLevel,
    modelAccess,
    languagesArr,
    countriesArr,
    citiesArr,
    resetInsideFilter
  }
})
